/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

import UIkit from 'uikit'

import GenericModal from 'app/views/components/Modals/GenericModal'

class ModalThirdPartyCookies extends React.Component {
  constructor(props) {
    super(props)
    this.modal = null
    this.renderInstructions = this.renderInstructions.bind(this)

    this.isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0
    this.isFirefox = typeof InstallTrigger !== 'undefined'
    this.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]' })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))
    this.isIE = /*@cc_on!@*/false || !!document.documentMode
    this.isEdge = !this.isIE && !!window.StyleMedia
    this.isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) && !this.isOpera
    this.isEdgeChromium = this.isChrome && (navigator.userAgent.indexOf('Edg') !== -1)
  }

  renderChromeModal() {
    return (
      <>
        <h2>Chrome Instructions</h2>
        <h4>Step 1: Go to Settings</h4>
        <p>
          Click on  the 3 dots at the top right next to the search bar and click
          "Settings", or use the <code>Command</code> + <code>,</code> keyboard shortcut.
        </p>
        <h4>Step 2: Go to "Privacy and security"</h4>
        <p>
          On the left menu click on "Advanced" and then select "Privacy and security"
        </p>
        <h4>Step 3: Go to cookies options</h4>
        <p>
          Click on "Site Settings" and then click on "Cookies and site data"
        </p>
        <h4>Step 4: Add HackEDU to Allowed sites</h4>
        <p>
          Finally, under the "Allow" heading, click on Add and enter this URL:
          <code>[*.]sandbox-hackedu.com</code>. Leave the "All cookies, on this
          site only" option unchecked.
        </p>
      </>
    )
  }

  renderSafariModal() {
    return (
      <>
        <h2>Safari Instructions</h2>
        <p>
          Safari does not allow whitelisted domains for third party tracking,
          so you have to enable it for all sites if you want it enabled.
        </p>
        <p>
          Because of this, we recommend using Popout Mode, or using Google
          Chrome, and only whitelisting HackEDU.
        </p>
        <p>
          If you want to disable third party tracking in Safari anyway, you can
          follow the instructions below:
        </p>
        <h4>Step 1: Go to Preferences </h4>
        <p>
          Go to the Safari menu and click on preferences. Or use the
          <code>Command</code>
          +
          <code>,</code>
          &nbsp;
          shortcut
        </p>
        <h4>Step 2: Disable block third party cookies option</h4>
        <p>
          Go to the privacy tab and uncheck the option "Prevent cross-site tracking".
          After this you are ready to use the sandbox normally.
        </p>
      </>
    )
  }

  renderFirefoxModal() {
    return (
      <div className="uk-text-justify">
        <h2>Firefox Instructions</h2>
        <h4>Step 1: Go to preferences </h4>
        <p>
          Click on  the 3 dots at the top right next to the search bar
          and click "Preferences"
        </p>
        <h4>Step 2: Go to "Privacy and security"</h4>
        <p>
          On the left menu click on "Privacy and security"
        </p>
        <h4>Step 3: Enable the third party cookies</h4>
        <p>
          If third party cookies are disabled the  most probably is that you
          have the "Custom" option selected and "All third-party cookies" option
          picked. To enable the cookies you can uncheck the "Cookies" checkbox
          or pick the option "Cross-site and social media trackers" next to this
          checkbox. After this just click on "Reload all tabs" and continue
          using the sandbox normally.
        </p>
      </div>
    )
  }

  renderOperaModal() {
    return (
      <>
        <h2>Opera Instructions</h2>
        <h4>Step 1: Go to Settings </h4>
        <p>
          Open the settings Menu by clicking on the
          &nbsp;
         <span data-uk-icon="icon: cog;" />
          &nbsp;
          icon.
        </p>
        <h4>Step 2: Go to "Privacy and security"</h4>
        <p>
          On the left menu click "Advanced" and go to "Privacy & Security" option.
        </p>
        <h4>Step 3: Go to site cookies options</h4>
        <p>
          Click on the option "Site settings" and then on "Cookies and site  data".
        </p>
        <h4>Step 4: Enable  third-party cookies</h4>
        <p>
          Finally disable the option "Block third-party cookies" and continue
          using the sandbox normally.
        </p>
      </>
    )
  }

  renderEdgeModal() {
    return (
      <>
        <h2>Microsoft Edge instructions</h2>
        <h4>1.- Go to Settings </h4>
        <p>
          Click on the More actions button in the top right corner and select Settings.
        </p>
        <h4>2.- Go to Cookies section</h4>
        <p>
          Click View Advanced Settings. You’ll need to scroll down to the bottom of the page.
        </p>
        <h4>3.- Enable cookies</h4>
        <p>
          Press the dropdown arrow under the Cookies field and select "Don't block cookies" option. After this you can continue using the sandbox normally.
        </p>
      </>
    )
  }

  renderOtherBrowsers() {
    return (
      <>
        <h2>Enable third-party cookeis option</h2>
        <p>
          Go to  the browser settings or preferences and search for the cookies section (Generally  under advance options or privacy and security).
          After you find the cookies section disable  the option "Block third-party cookeis" and continue using the sandbox normally.
        </p>
      </>
    )
  }

  renderInstructions() {
    this.modal.hide()
    if (this.isChrome) {
      UIkit.modal.alert(renderToStaticMarkup(this.renderChromeModal()))
    } else if (this.isSafari) {
      UIkit.modal.alert(renderToStaticMarkup(this.renderSafariModal()))
    } else if (this.isFirefox) {
      UIkit.modal.alert(renderToStaticMarkup(this.renderFirefoxModal()))
    } else if (this.isOpera) {
      UIkit.modal.alert(renderToStaticMarkup(this.renderOperaModal()))
    } else if (this.isEdge) {
      UIkit.modal.alert(renderToStaticMarkup(this.renderEdgeModal()))
    } else {
      UIkit.modal.alert(renderToStaticMarkup(this.renderOtherBrowsers()))
    }
  }

  render() {
    return (
      <>
        <GenericModal
          ref={(ref) => { this.modal = ref }}
          id="third-party-cookies-modal"
          title="Third Party Cookies Blocked"
          noStack
          buttons={(
            <>
              <button
                type="button"
                className="uk-button uk-button-primary uk-margin-left"
                onClick={this.renderInstructions}
              >
                View Instructions
              </button>
            </>
          )}
          body={(
            <>
              <p>
                We have detected that you currently have the "Block third party
                cookies" option enabled in your browser, which may affect this
                lesson.
              </p>
              <p>
                To use this sandbox, either use
                &nbsp;
                <a
                  onClick={() => {
                    this.modal.hide()
                    document.getElementById('popout-mode-btn').click()
                  }}
                >
                  Popout Mode
                </a>
                &nbsp;
                or click
                &nbsp;
                <a onClick={this.renderInstructions}>
                  View Instructions
                </a>
                &nbsp;
                to see how to enable our sandbox's
                cookies in your browser.
              </p>
            </>
          )}
        />
      </>
    )
  }
}

export default ModalThirdPartyCookies
